import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-331dca33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewing-card-home-details" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { class: "truncate text-lg font-bold viewing-card-home_title" }
const _hoisted_4 = { class: "truncate font-semibold viewing-card-home_postal" }
const _hoisted_5 = { class: "flex flex-col text-xs leading-normal align-between viewing-card-home_info" }
const _hoisted_6 = { class: "flex space-x-1 items-center" }
const _hoisted_7 = { class: "flex space-x-1 items-center" }
const _hoisted_8 = { class: "flex space-x-1 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))

import IconBed from '@/components/icons/IconBed.vue'
    import IconHouse from '@/components/icons/IconHouse.vue'
    import IconSquareMeter from '@/components/icons/IconSquareMeter.vue'
    import { computed, toRefs } from 'vue'
    import { Viewing } from '@/interface'
    import GoogleMapsRouteDirections from '@/components/ui/GoogleMapsRouteDirections.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    viewing: null
  },
  setup(__props: any) {

const props = __props as { viewing: Viewing }

    
    const { viewing } = toRefs(props)

    const relatieAddress = computed(() => {
        const adres = viewing.value?.relatie?.adresgegevens?.huisadres

        return formatAddress(adres?.huisadresRegel1, adres?.huisadresHuisnummer, adres?.huisadresHuisnummertoevoeging, adres?.huisadresPlaats)
    })

    const propertyAddress = computed(() => {
        const adres = viewing.value?.adres

        return formatAddress(adres?.straat, adres?.huisnummer, adres?.huisnummertoevoeging, adres?.plaats)
    })

    function formatAddress(
        straat: string|null,
        huisnummer: string|number|null,
        huisnummertoevoeging: string|null,
        plaats: string|null,
    ) {
        const addressParts = [
            straat,
            huisnummer,
            huisnummertoevoeging,
            plaats,
        ]

        return addressParts
            .map(part => part === null ? '' : part.toString().trim())
            .filter(part => part.length > 0)
            .join(' ')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(viewing).adres.straat) + " " + _toDisplayString(_unref(viewing).adres.huisnummer) + _toDisplayString(_unref(viewing).adres.huisnummertoevoeging), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(viewing).adres.postcode) + ", " + _toDisplayString(_unref(viewing).adres.plaats), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(IconHouse, {
          class: "viewing-card-home-svg",
          size: 12
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(viewing).algemeen.woonhuissoort), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(IconBed, {
          class: "viewing-card-home-svg",
          size: 12
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(viewing).algemeen.aantalSlaapkamers), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(IconSquareMeter, {
          class: "viewing-card-home-svg",
          size: 12
        }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_unref(viewing).algemeen.woonoppervlakte) + "m", 1),
          _hoisted_9
        ])
      ])
    ]),
    _createVNode(GoogleMapsRouteDirections, {
      origin: _unref(relatieAddress),
      destination: _unref(propertyAddress)
    }, null, 8, ["origin", "destination"])
  ]))
}
}

})